import { action, observable } from 'mobx';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { RoadmapResponseDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

interface IRoadmap {
    createdBy: string;
    creationDate: string;
    deleted: boolean;
    lastChangeDate: string;
    lastChangedBy: string;
    roadmapDescription: string;
    roadmapId: number;
    roadmapName: string;
    status: string;
}

export class RoadmapVM {

    @observable Roadmap: RoadmapResponseDto[] = [];
    @observable roadmapDescription: string = '';
    @observable text: string = '';
    @observable readonly userName: string = localStorage['username'];

    @action.bound updateCallback(value) {
        this.text = value;
    }

    @action.bound async updateRoadmap() {
        const updateData: RoadmapResponseDto = {
            createdBy: this.Roadmap[0]['createdBy'],
            creationDate: this.Roadmap[0]['creationDate'],
            deleted: this.Roadmap[0]['deleted'],
            lastChangeDate: Date.now().toString(),
            lastChangedBy: this.userName,
            roadmapDescription: this.text,
            roadmapId: this.Roadmap[0]['roadmapId'],
            roadmapName: this.text,
            status: this.Roadmap[0]['status']
        }
        await PRJAPI.RoadmapController.updateRoadmapUsingPOST(updateData);
    }


    @action.bound async getRoadmap() {
        try {
            const response: any = await PRJAPI.RoadmapController.getAllRoadmapsUsingGET();
            if (response.data.length > 0) {
                this.Roadmap = response.data;
                this.roadmapDescription = response.data[0]['roadmapDescription'];
            }
        } catch (error) {
            console.error('getRoadmap error:', error);
        }
    }

}
